export const complaitnsTypeProcessing = [
    { label: 'нарахування бонусів', value: 1 }
]

export const listenTypeProcessing = [
    { label: 'Всі', value: "all" },
    { label: 'Не опрацьовані', value: "0" },
    { label: 'Опрацьовані', value: "1" },
];